<template src="./index.html"></template>
<script>
import data from './data.js';
import config from '../../../../configHttp.js';
import { MainFunction } from '@/components/util/Function/MainFunction';
import { page, summary, detail, compare, updateDetail } from '@/api/taxInspection';

export default {
    name: 'TaxInspection',
    data: function () {
        return {
            tableKey: 0,
            tableHeadData: data.configHeadData,
            tablePagination: data.tablePagination,
            tableData: [],
            summaryData: { total: 0, system: 0, offline: 0, nonZero: 0, consistent: 0, inconsistent: 0, unchecked: 0 },
            searchlist: data.searchlist,
            searchdata: data.searchdata,
            selectedRows: [],
            detailVisible: false,
            currentDetail: null,
            detailTableData: [],
            editedDetailIds: [],
            detailHeadData: [
                { title: '序号', prop: 'serialNumber', width: '70' },
                { title: '税局税表', prop: 'taxBureauForm', width: '230' },
                { title: '系统配置税表', prop: 'declarationForm', width: '230' },
                { title: '检查状态', prop: 'checkStatus', width: '140', custom: true },
                { title: '差异/人工说明', prop: 'differenceDescription', width: '230', custom: true },
                { title: '处理人', prop: 'operator', width: '120' }
            ]
        };
    },
    mounted: function () {
        this.searchdata.period = MainFunction.$getdefultMonth();
        this.initTableData();
    },
    methods: {
        submitSearch() {
            this.tablePagination.pageNum = 1;
            this.initTableData();
        },
        summarySearch(params) {
            this.searchdata.result = params.result;
            this.searchdata.declarationType = params.declarationType || '';
            this.tablePagination.pageNum = 1;
            this.initTableData();
        },
        selectSizeChange(e) {
            this.tablePagination.pageSize = e;
            this.initTableData();
        },
        selectCurrentChange(e) {
            this.tablePagination.pageNum = e;
            this.initTableData();
        },
        selectionChange(rows) {
            this.selectedRows = rows || [];
        },
        sortChange(sort) {
            if (sort && sort.prop && !sort.order) {
                this.$nextTick(() => {
                    let table = this.$refs.tablebox && this.$refs.tablebox.$refs.mu;
                    if (table) {
                        table.sort(sort.prop, 'ascending');
                    }
                });
                return;
            }
            this.tablePagination.pageNum = 1;
            this.searchdata.sort = sort && sort.prop ? sort.prop : '';
            this.searchdata.order = sort && sort.order === 'descending' ? 'desc' : 'asc';
            this.initTableData();
        },
        initTableData() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.tablePagination.pageNum;
            params.size = this.tablePagination.pageSize;
            page(params).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = res.data.data.records;
                    this.tablePagination.total = res.data.data.total;
                    this.tablePagination.current = res.data.data.current;
                    this.tablePagination.size = res.data.data.size;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
            summary({ period: this.searchdata.period }).then((res) => {
                if (res.data.code == 1) {
                    this.summaryData = res.data.data;
                }
            });
        },
        compareInspection() {
            if (this.searchdata.period !== MainFunction.$getdefultMonth()) {
                this.$message.warning('非当期不支持比对检查');
                return;
            }
            let rows = this.$refs.tablebox.getSelectionval();
            if (!rows.length) {
                this.$message.warning('请选择需要比对检查的数据');
                return;
            }
            compare(rows.map((item) => item.companyId)).then((res) => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.initTableData();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        showDetail(row) {
            detail({ inspectionId: row.id }).then((res) => {
                if (res.data.code == 1) {
                    this.currentDetail = row;
                    this.detailTableData = res.data.data;
                    this.editedDetailIds = [];
                    this.detailVisible = true;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        markDetailEdited(row) {
            if (this.editedDetailIds.indexOf(row.id) === -1) {
                this.editedDetailIds.push(row.id);
            }
        },
        saveDetail() {
            if (!this.editedDetailIds.length) {
                this.$message.warning('请先修改差异/人工说明');
                return;
            }
            let updates = this.detailTableData
                .filter((item) => this.editedDetailIds.indexOf(item.id) !== -1)
                .map((item) => ({
                    id: item.id,
                    differenceDescription: item.differenceDescription
                }));
            updateDetail(updates).then((res) => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.showDetail(this.currentDetail);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        declarationTypeFormat(value) {
            let item = data.searchlist.find((item) => item.prop === 'declarationType');
            let option = item.selectval.find((option) => option.value === value);
            return option ? option.label : value;
        },
        resultFormat(value) {
            let item = data.searchlist.find((item) => item.prop === 'result');
            let option = item.selectval.find((option) => option.value === value);
            return option ? option.label : value;
        },
        formatDetailPeriod(period) {
            return period ? period.slice(0, 4) + '年' + period.slice(4).padStart(2, '0') + '期' : '';
        },
        exportData() {
            let rows = this.$refs.tablebox.getSelectionval();
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.selectedIds = rows.map((item) => item.companyId);
            this.$downloadcommon({
                downUrl: config.baseURL + '/taxInspection/export',
                typeObj: {
                    toForm: false,
                    fileName: '税种检查_' + this.searchdata.period,
                    fileType: 'xlsx'
                },
                params: params
            });
        }
    }
};
</script>
<style lang="less" src="./index.less" scoped></style>
